import {Component, Inject, OnInit, ViewEncapsulation} from "@angular/core";
import {AuthService} from "../../../services/auth.service";
import {BusyIconService} from "../../../services/busy.service";
import {AuthoritySettings} from "../../../models/AuthoritySettings";
import {AppConstants} from "../../../app.constants";
import {OidcClientService} from "../../../services/oidcClient.service";
import {User} from "oidc-client";
import {ActivatedRoute, Router} from "@angular/router";
import {L10N_LOCALE, L10nLocale, L10nTranslationService} from "angular-l10n";

@Component({
  selector: "external-login",
  templateUrl: "externalLogin.template.html",
  styleUrls: ["../login.style.less"],
  encapsulation: ViewEncapsulation.None
})
export class ExternalLoginComponent implements OnInit {

  currentSettingsId: string;
  authorities: AuthoritySettings[] = [];
  currentUser: User = null;
  currentSettingsName: string;

  registerUser: boolean = false;
  userFirstName: string = "";
  userLastName: string = "";
  userGender: number = 0;
  genderList: any[] = [];
  registerUserValid: boolean = false;

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale, private translation: L10nTranslationService,
              private authService: AuthService,
              private busyIconService: BusyIconService,
              private oidcClientService: OidcClientService,
              private router: Router,
              private route: ActivatedRoute) {
  }

  changeLanguage(language: string): void {
    // TODO ?
    // this.localeService.setCurrentLanguage(language.toLowerCase());
    localStorage.setItem("currentLanguage", language.toLowerCase());
    this.createGenderList();
  }

  authorityChanged() {
    localStorage.setItem(AppConstants.AUTH_LAST_SELECTED_CLIENT, this.currentSettingsId);
    this.initClient();
  }

  ngOnInit(): void {
    const language = localStorage.getItem("currentLanguage");
    if (language) {
      this.changeLanguage(language);
    } else {
      this.createGenderList();
    }
    this.handleLogout();
    const lastAuthority = localStorage.getItem(AppConstants.AUTH_LAST_SELECTED_CLIENT);
    if (lastAuthority) {
      this.currentSettingsId = lastAuthority;
    }
    this.authService.getExternalAuthorities().subscribe((response) => {
      this.authorities = response.map((au) => {
        au.clientSettings.authorityId = au.authorityId;
        return au.clientSettings;
      });
      this.initClient();
    });
  }

  createGenderList(): void {
    this.genderList = [
      {id: 1, name: this.translation.translate("REGISTRATION.MALE")},
      {id: 2, name: this.translation.translate("REGISTRATION.FEMALE")}
    ];
  }

  handleLogout() {
    if (this.route.snapshot.queryParamMap.has("logout")) {
      localStorage.removeItem(AppConstants.AUTH_LAST_SELECTED_CLIENT);
    }
  }

  logout() {
    this.oidcClientService.logout()
      .then(() => {
        this.router.navigate(["/login"], {queryParams: {unhandled: "true"}, queryParamsHandling: "preserve"});
      })
      .catch((error) => console.error(error));
  }

  initClient(): void {
    const settings = this.authorities.find((s) => s.authorityId === this.currentSettingsId);
    if (!settings) {
      return;
    }
    this.currentSettingsName = settings.name;
    localStorage.setItem(AppConstants.AUTH_LAST_SELECTED_CLIENT, settings.authorityId);
    this.oidcClientService.initUserManager(settings);
    this.oidcClientService.getUser().then((user) => {
      this.currentUser = user;
      this.oidcClientService.renewToken().then((newUser) => {
        this.currentUser = newUser;
      }).catch((error) => {
        this.currentUser = null;
        console.error(error);
      });
    }).catch((error) => console.error(error));
  }

  startLogin() {
    if (!this.currentUser) {
      this.oidcClientService.login()
        .catch((error) => console.error(error));
    }
  }

  loginToClient() {
    if (this.currentUser) {
      this.oidcClientService.renewToken().then((user) => {
        if (user) {
          this.authService.loginSSO(user.access_token, this.currentSettingsId).subscribe((response) => {
            if (response.registerAccount) {
              // do registration
              this.registerUser = true;
              this.createGenderList();
            } else {
              this.router.navigate(["/home"]);
            }
          });
        }
      });
    }
  }

  registerUserInNOCCO() {
    if (this.currentUser && this.registerUserValid) {
      this.authService.registerSSO(this.currentUser.access_token, this.currentSettingsId, this.userFirstName, this.userLastName, parseInt(this.userGender.toString(), 10)).subscribe((response) => {
        if (response) {
          this.router.navigate(["/home"]);
        }
      });
    }
  }

  checkRegisterUserValid(): void {
    this.registerUserValid = this.userFirstName.length > 0 && this.userLastName.length > 0 && this.userGender > 0;
  }

  backToLogin() {
    this.router.navigate(["/login"]);
  }
}
